export default __webpack_public_path__ + "static/media/commercial-laundry-image.be1d3545.webp";